import React, { useEffect, useState, useRef } from 'react';
import '../styles/login.css';
import { useNavigate } from "react-router-dom"
import { login, validateLogin, saltGeneration, setLoginSuccess, handleRSAEncrypt, handleRSAVerify, isEmpty } from '../js/helper';
import { getAccessToken, sendLoginUser } from "../js/api/auth";
import Loader from './Loader';
import secureLocalStorage from 'react-secure-storage';

export const LoginPage = () => {
  const ref = useRef(null)
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [getInvalidUser, setInvalidUser] = useState();
  const [form, setForm] = useState({
    username: "",
    password: "",
  });

  const [errors, setError] = useState({

  })

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });

  }

  let inputData = {
    userId: form.username,
    password: form.password
  };

  function onSubmitForm(e) {
    setInvalidUser('');
    sessionStorage.setItem("userId", form.username);
    e.preventDefault();
    login('success')
    setError(validateLogin(form))
    if (Object.keys(errors).length === 0 && (form.username !== "" && form.password !== "")) {
      Login();
    }
  }
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  const Login = async () => {
    setIsLoading(true)

    localStorage.clear(); // Clears all data stored in local storage
    secureLocalStorage.removeItem('TDB-PROMOTER-DASHBOARD');

    const accessResponse = await getAccessToken();
    let [encryptedPass, saltData, accessToken] = saltGeneration(inputData, accessResponse.data.access_token);
    
    inputData.password = encryptedPass;
    const randomUUID = crypto.randomUUID();
    inputData.uuid = handleRSAEncrypt(randomUUID);

    sendLoginUser(inputData, accessToken)
      .then((res) => {
        setInvalidUser('');
        if (res.data.status === "x05") {
          const isVerified = handleRSAVerify(randomUUID, res.data.data.signedUUID);
          if(!isVerified) {
            setIsLoading(false)
            setInvalidUser("We are unable to process your login request , please contact admin");
          } else {
            login('success');
            setLoginSuccess(res.data.data, saltData);
            setIsLoading(false)
            sessionStorage.setItem("allowPasswordChange", "true");
            navigate("/Change-Password");
          }
        }
        else if (res.data.status === "x03" || res.data.status === "x04" || res.data.status === "x07") {
          setIsLoading(false)
          setInvalidUser(res.data.message);
        } else if (res.data.status === "00") {
          const isVerified = handleRSAVerify(randomUUID, res.data.data.signedUUID);
          if(!isVerified) {
            setIsLoading(false)
            setInvalidUser("We are unable to process your login request , please contact admin");
          } else {
            login('success');
            setLoginSuccess(res.data.data, saltData);
            sessionStorage.removeItem("allowPasswordChange");
            navigate('/merchantpage');
          }
        } else {
          setIsLoading(false)
          setInvalidUser("We are unable to process your login request , please contact admin");
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false)
        setInvalidUser("We are unable to process your login request , please contact admin");
      })
     
  }

  useEffect(() => {
    console.log("Login page ");
    localStorage.removeItem("userToken")
    sessionStorage.removeItem("allowPasswordChange");
    if (ref.current) return;
    ref.current = true;
  }, [errors])

  return (
    <div className="Login-page">
      {isLoading == true ? <Loader /> : ""}
      <div className="container">
        <div className="login-page">
          <div className="login-label pb-5">
            <div className="login-title"><p className='mb-0'>Welcome back!</p><p className='mb-0'>to <span className="text-color">Purple App</span></p></div>
            <span className="sub-title text-secondary">Login gamit ang access id at password</span>
          </div>
          <form onSubmit={onSubmitForm} autoComplete="off">
            <p className='text-center text-danger invalid-user'>{getInvalidUser}</p>
            <div className="form-group">
              <label className="form-label">Username</label>
              <input type="text" className="form-control mb-2" name="username" value={form.username}
                onChange={handleChange}
                autoComplete="off" />
              {errors.username && <p style={{ color: "red", fontSize: "13px", fontWeight: "bold" }}>{errors.username}</p>}
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input type={passwordShown ? "text" : "password"} className="form-control mb-2" name="password"
                value={form.password}
                onChange={handleChange}
              /><div className='toggle-eye'><i className={passwordShown ? "fa fa-eye" : "fa fa-eye-slash"}
                id="togglePassword" onClick={togglePassword}></i></div>
              {errors.password && <p style={{ color: "red", fontSize: "13px", fontWeight: "bold" }}>{errors.password}</p>}
            </div>

            <div className="form-group text-end ">
              <a href="#" className="forgot-msg text-dark" data-bs-toggle="modal" data-bs-target="#exampleModal">Forgot Password?</a>
            </div>
            <div className="form-group">
              <button type="submit" disabled={isEmpty(inputData.userId) || isEmpty(inputData.password)} className="btn btn-dark w-100 form-control font-weight-bold">Login</button>
            </div>
          </form></div>

        <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title" id="exampleModalLabel" >Forgot Password</h6>
              </div>
              <div className="modal-body">
                I-reset natin yan! Call your territory manager for a temporary password
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-danger" data-bs-dismiss="modal">ok</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}